<template>
  <div>
    <h1>Count: {{count}} | Half: {{halfCount}} | Double: {{doubleup}}</h1>
    <div>
      <v-btn small color="primary" @click="increment">count++</v-btn>
      <v-btn small color="primary" @click="reset_counter">reset</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      devData: {}
    };
  },
  mounted() {
    // this.getDevStatus();
  },
  methods: {
    increment() {
      this.$store.commit("increment");
    },
    reset_counter() {
      this.$store.dispatch("reset_counter");
    }
  },
  computed: {
    count: function() {
      console.log(this.$store.state.count);
      return this.$store.state.count;
    },
    doubleup: function() {
      return this.$store.getters.doubleup;
    },
    halfCount: function() {
      return this.count / 2;
    }
  }
};
</script>